import { AXES, BUILDS, PHOTOS, WASTE_OPTIONS, WASTE_SOFTWARE, WHY_WASTE } from '../catalog';
import { useLang } from '../lang';
import { Pic } from '../pic';
import { Faq } from '../sections/Faq';
import { Closer, HowYouStart, LineHero, SectionHead, Subnav, Why } from '../sections/Shared';
import { Software } from '../sections/Software';

const SUBNAV = [
  { href: '#software', key: 'nav.software' },
  { href: '#where', key: 'nav.where' },
  { href: '#start', key: 'nav.start' },
  { href: '#faq', key: 'nav.faq' },
] as const;

export function Waste() {
  return (
    <>
      <LineHero line="waste" />
      <Subnav items={SUBNAV} />
      <Software prefix="wsoft" features={WASTE_SOFTWARE} />
      <Options />
      <Why prefix="wwhy" ids={WHY_WASTE} tone="soft" />
      <Applications />
      <HowYouStart line="waste" prefix="wstart" photo={PHOTOS.mountBin} specs={['bins', 'hardware', 'software', 'duration']} />
      <Faq prefix="wfaq" />
      <Closer titleKey="close.waste.title" line="waste" />
    </>
  );
}

function Options() {
  const { t } = useLang();
  return (
    <section className="band band-soft uses" aria-labelledby="wopt-title">
      <div className="frame">
        <SectionHead id="wopt-title" prefix="wopt" />
        <ul className="uses-grid uses-grid-4" role="list">
          {WASTE_OPTIONS.map((id) => (
            <li key={id} data-reveal>
              <p className="mono soft-status-label">{t('soft.on_request')}</p>
              <h3 className="h4">{t(`wopt.${id}`)}</h3>
              <p>{t(`wopt.${id}.d`)}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function Applications() {
  const { t } = useLang();
  return (
    <section className="band apps" id="where" aria-labelledby="wapp-title">
      <div className="frame">
        <SectionHead id="wapp-title" prefix="wapp" />
        <dl className="spec hw-axes choose-strip" data-reveal>
          {AXES.map((k) => (
            <div key={k}>
              <dt className="mono">{t(`choose.${k}`)}</dt>
              <dd>{t(`choose.${k}.v`)}</dd>
            </div>
          ))}
        </dl>
        <ul className="hw-builds" role="list">
          {BUILDS.map((b) => (
            <li key={b.id} data-reveal>
              <figure>
                <Pic photo={b.photo} alt={t(`wapp.${b.id}.alt`)} />
              </figure>
              <h3 className="h3">{t(`wapp.${b.id}`)}</h3>
              <p>{t(`wapp.${b.id}.d`)}</p>
              <p className="hw-sku">
                <span className="visually-hidden">{t('wapp.sku')}: </span>
                <span translate="no" dir="ltr">
                  {b.sku}
                </span>
              </p>
            </li>
          ))}
        </ul>
        <p className="apps-also" data-reveal>
          {t('wapp.also')}
        </p>
      </div>
    </section>
  );
}
